import { coreClient as client } from '@app/helpers/requests/client';

export const completeAppTutorial = () => client.post(`/v1/tours`);

export const fetchRestartAppTutorial = () => client.post(`/v1/tours/reset`);
